const MIXPANEL_EVENTS = {
  PAYMENTS_EVENTS: {
    GET_ALL_PAYMENTS_API: 'get_all_payments_api_call',
    GET_NEW_PAYMENTS_API: 'get_new_payments_api_call',
    UPDATE_PAYMENT_API: 'update_payment_api_call',
    CANCEL_PAYMENT_API: 'cancel_payment_api_call',
    GET_PAYMENT_TYPES_API: 'get_payment_types_api_call',
    GET_PAYMENTS_V2_API: 'get_payments_v2_api_call',
  },
  INSIGHT_EVENTS: {
    INSIGHTS_TAB_VIEWED: 'insights_tab.viewed',
    INSIGHT_CARD_EXPANDED: 'insight_card.expanded',
    INSIGHT_HISTORY_VIEWED: 'insight_history.viewed',
  },
  FNOL_EVENTS: {
    POST_FNOL_API_CALL: 'post_fnol_api_call',
    FNOL_POLICY_SELECTED: 'fnol_policy_selected',
    FNOL_POLICY_CHANGED: 'fnol_policy_changed',
  },
  POLICIES_EVENTS: {
    POLICY_RESPONSE_API_CALL: 'policy_response_api_call',
    POLICY_SELECTION_RESPONSE: 'policy_selection_response',
  },
  API_CALLS_EVENTS: {
    POST_DOCUMENT_API_CALL: 'post_document_api_call',
    GET_CLAIM_API_CALL: 'get_claim_api_call',
    PATCH_CLAIM_API_CALL: 'patch_claim_api_call',
    POST_INVOLVED_API_CALL: 'post_involved_api_call',
    PATCH_INVOLVED_API_CALL: 'patch_involved_api_call',
    GET_EXPOSURE_API_CALL: 'get_exposure_api_call',
    MOI_STATUS_UPDATE_API_CALL: 'moi_status_update_api_call',
    POST_EXPOSURES_API_CALL: 'post_exposures_api_call',
    POST_EXPOSURE_CLOSE_API_CALL: 'post_exposure_close_api_call',
    PUT_EXPOSURE_DEDUCTIBLE_API_CALL: 'put_exposure_deductible_api_call',
    POST_NOTES_API_CALL: 'post_notes_api_call',
    POST_REMINDERS_API_CALL: 'post_reminders_api_call',
    POST_ASSIGNMENTS_API_CALL: 'post_assignments_api_call',
    GET_SIU_API_CALL: 'get_siu_api_call',
    PUT_SIU_API_CALL: 'put_siu_api_call',
    POST_CLOSE_CLAIM_API_CALL: 'post_close_claim_api_call',
    PUT_RESERVES_API_CALL: 'put_reserves_api_call',
    POST_PAYMENT_API_CALL: 'post_payment_api_call',
    GET_DOCUMENT_URL_API_CALL: 'get_document_url_api_call',
    GET_EXPOSURE_DOCUMENT_API_CALL: 'get_exposure_document_api_call',
    GET_CLAIM_DOCUMENTS_API_CALL: 'get_claim_documents_api_call',
    POST_MULTIPLE_DOCUMENTS_API_CALL: 'post_multiple_documents_api_call',
    DELETE_DOCUMENT_API_CALL: 'delete_document_api_call',
    GET_POLICY_API_CALL: 'get_policy_api_call',
    POST_FNOL_DRAFT_API_CALL: 'post_fnol_draft_api_call',
    POST_DISMISS_NOTIFICATIONS: 'post_dismiss_notifications',
    GET_CLAIM_NOTIFICATIONS: 'get_claim_notifications',
    POST_ASSIGN_EXPOSURE_BULK_API_CALL: 'post_assign_exposure_bulk_api_call',
    POST_ASSIGN_ADJUSTER_BULK_API_CALL: 'post_assign_adjuster_bulk_api_call',
    POST_CHANGE_CLAIM_OWNER_API_CALL: 'post_change_claim_owner_api_call',
    GET_DATA_EXPORT_ERD_SCHEMA_API_CALL: 'get_data_export_erd_schema_api_call',
    EMAIL_FROM_TEMPLATE_API_CALL: 'email_from_template_api_call',
    GET_SUBROGATION_API_CALL: 'get_subrogation_api_call',
    POST_SUBROGATION_API_CALL: 'post_subrogation_api_call',
    PATCH_SUBROGATION_API_CALL: 'patch_subrogation_api_call',
    POST_SUBROGATION_CLOSE_API_CALL: 'post_subrogation_close_api_call',
    POST_SUBROGATION_REOPEN_API_CALL: 'post_subrogation_reopen_api_call',
    POST_SUBROGATION_AMOUNT_API_CALL: 'post_subrogation_amount_api_call',
    GET_SALVAGE_API_CALL: 'get_salvage_api_call',
    POST_SALVAGE_API_CALL: 'post_salvage_api_call',
    PATCH_SALVAGE_API_CALL: 'patch_salvage_api_call',
    POST_SALVAGE_CLOSE_API_CALL: 'post_salvage_close_api_call',
    POST_SALVAGE_REOPEN_API_CALL: 'post_salvage_reopen_api_call',
    POST_SALVAGE_AMOUNT_API_CALL: 'post_salvage_amount_api_call',
    GET_GENERAL_RECOVERIES_API_CALL: 'get_general_recoveries_api_call',
    POST_GENERAL_RECOVERY_API_CALL: 'post_general_recovery_api_call',
    POST_GENERAL_RECOVERY_GROUP_API_CALL: 'post_general_recovery_group_api_call',
    GET_ORGANIZATION_GENERAL_RECOVERIES_API_CALL: 'get_organization_general_recoveries_api_call',
    GET_ORGANIZATION_SUBROGATION_RECOVERIES_API_CALL: 'get_organization_subrogation_recoveries_api_call',
    GET_ORGANIZATION_SALVAGE_RECOVERIES_API_CALL: 'get_organization_salvage_recoveries_api_call',
    POST_CLAIM_STAGE_UPDATE_BULK_API_CALL: 'post_claim_stage_update_bulk_api_call',
    POST_CLAIM_FLAGS_APPLY_BULK_API_CALL: 'post_claim_flags_apply_bulk_api_call',
    POST_CLAIM_FLAGS_REMOVE_BULK_API_CALL: 'post_claim_flags_remove_bulk_api_call',
    PUT_CLAIM_MILESTONE_API_CALL: 'put_claim_milestone_api_call',
    DELETE_CLAIM_MILESTONE_API_CALL: 'delete_claim_milestone_api_call',
    GET_EXTERNAL_CLAIM_NUMBERS_API_CALL: 'get_external_claim_numbers_api_call',
    GET_EXTERNAL_CLAIM_NUMBER_API_CALL: 'get_external_claim_number_api_call',
    POST_EXTERNAL_CLAIM_NUMBER_API_CALL: 'post_external_claim_number_api_call',
    PATCH_EXTERNAL_CLAIM_NUMBER_API_CALL: 'patch_external_claim_number_api_call',
    DELETE_EXTERNAL_CLAIM_NUMBER_API_CALL: 'delete_external_claim_number_api_call',
    GET_CONTROL_FILE_CRITERIA_API_CALL: 'get_control_file_criteria_api_call',
    GET_CONTROL_FILE_API_CALL: 'get_control_file_api_call',
    PUT_CONTROL_FILE_API_CALL: 'put_control_file_api_call',
    DELETE_CONTROL_FILE_API_CALL: 'delete_control_file_api_call',
    GET_COMMUNICATIONS_API_CALL: 'get_communications_api_call',
    GET_COMMUNICATION_API_CALL: 'get_communication_api_call',
    PATCH_COMMUNICATION_API_CALL: 'patch_communication_api_call',
    GET_CLAIMS_API_CALL: 'get_claims_api_call',
    GET_CONTACTS_API_CALL: 'get_contacts_api_call',
    PATCH_CONTACT_API_CALL: 'patch_contact_api_call',
    POST_CHAT_API_CALL: 'post_chat_api_call',
    GET_CHAT_LIST_API_CALL: 'get_chat_list_api_call',
    GET_CHAT_API_CALL: 'get_chat_api_call',
    GET_LAST_CHAT_API_CALL: 'get_last_chat_api_call',
    POST_CHAT_MESSAGE_API_CALL: 'post_chat_message_api_call',
    GET_CHAT_EXCHANGE_API_CALL: 'get_chat_exchange_api_call',
    GET_CHAT_AVAILABILITY_API_CALL: 'get_chat_availability_api_call',
    DELETE_CHAT_API_CALL: 'delete_chat_api_call',
    POST_CHAT_REGENERATE_API_CALL: 'post_chat_regenerate_api_call',
    PATCH_CHAT_API_CALL: 'patch_chat_api_call',
    GET_CHAT_REALTIME_TOKEN_API_CALL: 'get_chat_realtime_token_api_call',
    POST_QUESTION_API_CALL: 'post_question_api_call',
    GET_QUESTION_API_CALL: 'get_question_api_call',
  },
  BROKER_EVENTS: {
    FIELD_ENABLED: 'broker_field_enabled',
    PRESENT_AT_FNOL: 'broker_present_at_fnol',
    MANUALLY_ASSIGNED: 'broker_manually_assigned',
    RESOLUTION_FAILURE: 'broker_resolution_failure_rate',
    REQUIRED_VALIDATION_BLOCK: 'broker_required_validation_block',
  },
} as const;

export default MIXPANEL_EVENTS;
